// Use by /messages/general/send

const showExcept = (indexToShow, fields) => {
  fields.forEach((item, index) => {
    if (index !== indexToShow) {
      item.hide();
    } else {
      item.show();
    }
  });
};

function showGroupFunction(value, fields) {
  switch (value) {
    case "input_nric":
      showExcept(0, fields);
      break;
    case "select_type":
      showExcept(1, fields);
      break;
    case "select_tier":
      showExcept(2, fields);
      break;
    case "file":
      showExcept(3, fields);
      break;
    default:
      showExcept(100, fields);
  }
}
// use this when support multiple catalogues and multiple quantity reward
// function showQuantityFunction(value, fields) {
//   switch(value) {
//     case 'fixed_quantity':
//       showExcept(0, fields)
//       break;
//     default:
//       showExcept(100, fields)
//   }
// }

$(document).ready(function () {
  const inputMemberIdFields = $("#input_nric_field").hide();
  const patronCategoryFields = $("#patron_catagory_fields").hide();
  const patronTierFields = $("#patron_tier_fields").hide();
  const importPatronFileFields = $("#import_patron_file_field").hide();

  // const fixedQuantityFields    = $("#fixed_quantity_field").hide();

  const hidePatronsFields = [
    inputMemberIdFields,
    patronCategoryFields,
    patronTierFields,
    importPatronFileFields,
  ];

  // const hideQuantityFields = [
  //   fixedQuantityFields
  // ]

  // const setInFileField = $('label[for=dashboard_message_batch_form_select_quantity_import_file]')
  //                          .parents('.form-check').hide();

  $(".send_to_buttons input[type=radio]:checked").each(function () {
    showGroupFunction(this.value, hidePatronsFields);

    // if (this.value === 'file') {
    //   setInFileField.show()
    // } else {
    //   setInFileField.hide()
    // }
  });

  $(".send_to_buttons")
    .find("input[type=radio]")
    .change(function () {
      showGroupFunction(this.value, hidePatronsFields);
      // if (this.value === 'file') {
      //   setInFileField.show()
      // } else {
      //   setInFileField.hide()
      // }
    });

  // $(".quantity_buttons input[type=radio]:checked").each( function() {
  //   showQuantityFunction(this.value, hideQuantityFields);
  // });

  // $(".quantity_buttons")
  //   .find("input[type=radio]")
  //   .change(function() {
  //     showQuantityFunction(this.value, hideQuantityFields);
  //   });
});
